export default function unpick(object, keysArray) {
  return Object.keys(object)
    .filter((key) => keysArray.indexOf(key) === -1)
    .reduce((result, key) => {
      result[key] = object[key];
      return result;
    }, {});
}
